import { render } from "./MyBills.vue?vue&type=template&id=d78da56e"
import script from "./MyBills.vue?vue&type=script&lang=js"
export * from "./MyBills.vue?vue&type=script&lang=js"

import "./MyBills.vue?vue&type=style&index=0&id=d78da56e&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__